/**
 * Canonical list of SBL programmes — import wherever a programme list is shown
 * (contact form, registration, free-course signup, etc.) so we avoid drift.
 * Source of truth: ProgrammesCataloguePage.js.
 */
export const SBL_PROGRAMMES = [
  "Foundations of School Leadership Certificate",
  "Operations Excellence & Administration Diploma",
  "People, Culture & Student Life Leadership Certificate",
  "School Growth, Brand & Sustainability Accelerator",
  "Governance, Risk & Institutional Compliance Diploma",
  "Digital School Systems & Innovation Leadership Certificate",
  "Auxiliary Services & School Enterprise Management Certificate",
  "Student Welfare, Health & Safeguarding Leadership Diploma",
  "Executive School Systems Leadership Programme",
  "Advanced School Systems Transformation Fellowship",
];
